import { store$, store } from '@redux/store';
import { map, filter, distinctUntilChanged, skip } from 'rxjs';
import { routingStateActions } from 'features/routing';
import {
  LocationType,
  ResultType,
  PlanStatus,
  SpecStatus,
  selectSubdirectory,
  UrlSubdirectoryTypes,
  hasModelHome,
} from 'features/searchResultsFacets';

const hasValue = (value) => !!value;
const onResultTypeChange$ = store$.pipe(map(selectSubdirectory), filter(hasValue), distinctUntilChanged(), skip(1));

// Get the page from the current state
const getPageFromCurrentState = (selector) => {
  const { condosAndTownHomes, singleFamily, resultType, homeStatus, custom, buildOnYourLot, locationType } = selector;

  const isStatePage = locationType === LocationType.State.toString();

  // the default is to use the resultType
  let subdirectory;

  switch (true) {
    case condosAndTownHomes && resultType === ResultType.Homes.toString():
      subdirectory = UrlSubdirectoryTypes.CondosAndTownHomes.toString();
      break;
    case condosAndTownHomes && resultType === ResultType.Communities.toString():
      subdirectory = UrlSubdirectoryTypes.CondoDevelopment.toString();
      break;
    case singleFamily && resultType === ResultType.Homes.toString():
      subdirectory = UrlSubdirectoryTypes.SingleFamilyHomes.toString();
      break;
    case singleFamily && resultType === ResultType.Communities.toString():
      subdirectory = UrlSubdirectoryTypes.SingleFamilyCommunities.toString();
      break;
    case custom && resultType === ResultType.Homes.toString():
      subdirectory = UrlSubdirectoryTypes.CustomHomes.toString();
      break;
    case buildOnYourLot && resultType === ResultType.Locations.toString():
      subdirectory = UrlSubdirectoryTypes.OnYourLot.toString();
      break;
    case (homeStatus === PlanStatus.ReadyToBuild.toString() || homeStatus === SpecStatus.ReadyToBuild.toString()) &&
      resultType === ResultType.Homes.toString():
      subdirectory = UrlSubdirectoryTypes.FloorPlans.toString();
      break;
    case hasModelHome(homeStatus) && (resultType === ResultType.Homes.toString() || isStatePage):
      subdirectory = UrlSubdirectoryTypes.ModelHomes.toString();
      break;
    default:
      subdirectory = resultType;
  }

  return subdirectory;
};

const updateUrlOnSubdirectoryChanged = (result) => {
  const routingState = store.getState()?.routingState;
  const currentSubdirectory = routingState?.urlSubdirectory;
  const newSubdirectory = getPageFromCurrentState(result);

  if (currentSubdirectory !== newSubdirectory) {
    // Deferred (not dispatched inline) to avoid re-entrant dispatch from this store$ subscription;
    // a microtask keeps the staleness window as small as possible for consumers of urlSubdirectory.
    const defer = (typeof queueMicrotask === 'function') ? queueMicrotask : (cb) => setTimeout(cb, 0);
    defer(() => store.dispatch(routingStateActions.updateSubdirectory(newSubdirectory)));
  }
};

onResultTypeChange$.subscribe(updateUrlOnSubdirectoryChanged);
